import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import MenuItem from '@material-ui/core/MenuItem';

import { accountSelector } from '../account/account-selectors';
import { loadAccounts } from '../account/actions/load-accounts';

import { UiKebabMenu } from '../ui/ui-kebab-menu';

import { STRIPE_WEBSITE_URL, SALESFORCE_ACCOUNT_BASE_URL } from '../config/config';

const mapStateToProps = (state: any, { accountId }: InputProps) => ({
  account: accountSelector(state, accountId),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    loadAccounts: () => dispatch(loadAccounts()),
  },
});

type InputProps = {
  accountId: number;
  stopPropagation?: boolean;
};

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & DispatchProps & ReduxProps;

export const AccountItemMenu = connect(
  mapStateToProps,
  mapDispatchToProps,
)(({ account, accountId, actions, stopPropagation }: Props) => {
  useEffect(() => {
    actions.loadAccounts();
  });

  if (!account) {
    return null;
  }

  return (
    <UiKebabMenu menuId={`account-menu-${accountId}`} stopPropagation={stopPropagation}>
      <MenuItem>
        <a
          href={`${STRIPE_WEBSITE_URL}/customers/${account.stripeCustomerId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Stripe Account
        </a>
      </MenuItem>
      {!!account.salesforceId && (
        <MenuItem>
          <a
            href={`${SALESFORCE_ACCOUNT_BASE_URL}/lightning/r/Account/${account.salesforceId}/view`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Salesforce Account
          </a>
        </MenuItem>
      )}
    </UiKebabMenu>
  );
});
